const TMenuItemScreen = {
    // English
    "enUS": {
        'ONLY_ONE': 'YOU CAN ONLY CHOOSE ONE',
        'FREE': 'Free',
        'INGREDIENTS': 'Ingredients',
        'MAIN': 'Personalize',
        'OPTIONAL': 'Included',
        'EXTRA_INGREDIENTS': 'Extras',
        'TOTAL': 'Total',
        'UPDATED': 'Updated',
        'UPDATED_DESC': 'Item updated successfully',
        'CONTINUE': 'Continue',
        'GO_BACK': 'Go Back',
    },
    // Spanish
    "esMX": {
        'ONLY_ONE': 'SOLO PUEDES ESCOGER UNO',
        'FREE': 'Gratis',
        'INGREDIENTS': 'Ingredientes',
        'MAIN': 'Personalizar',
        'OPTIONAL': 'Incluidos',
        'EXTRA_INGREDIENTS': 'Extras',
        'TOTAL': 'Total',
        'UPDATED': 'Actualizado',
        'UPDATED_DESC': 'Artículo ACTUALIZADO exitósamente',
        'CONTINUE': 'Continuar',
        'GO_BACK': 'Regresar',
    }
}
export default TMenuItemScreen;